import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { DealOriginApiService } from '../services/deal-origin-api.service';
import { DealOriginResponse } from '../models/deal-origin.model';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-deal-origin-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, PageBreadcrumbComponent, HasPermissionDirective],
  templateUrl: './deal-origin-list.component.html',
})
export class DealOriginListComponent implements OnInit {
  items: DealOriginResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: DealOriginApiService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll().subscribe({
      next: (data) => {
        this.items = data;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          err.error?.message || 'Error al cargar los orígenes de negocio';
        this.loading = false;
        console.error('Error:', err);
      },
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-deals/origenes/crear']);
  }

  editar(item: DealOriginResponse): void {
    this.router.navigate(['/config-deals/origenes/editar', item.id]);
  }

  async eliminar(item: DealOriginResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar origen',
      message: `¿Está seguro de eliminar el origen "${item.name}"?`,
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Origen', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.confirmDialog.alert({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el origen',
          variant: 'danger',
        });
        this.toast.error({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el origen',
        });
      },
    });
  }
}
